// Consolidated user-settings feature folder.
//
// Was three byte-for-byte-similar files (slice / hooks / api wrapper)
// of the same shape `siteSettings` / `siteGroupSettings` /
// `customerSettings` produce via `createSettingsFeature`.  The only
// real divergence was that `userId == null` is a valid sentinel
// meaning "the requesting user's `/me/` slot" — the factory now
// accepts a `keyFor` override so the cache keys that slot under
// `'self'`, and the existing public hook + selector names are
// re-exported unchanged so nothing at the call sites moves.

import * as UserSettingsApi from '@sophocles/api/userSettings';
import { createSettingsFeature } from '@sophocles/features/_settings/createSettingsFeature';

const feature = createSettingsFeature({
  name: 'userSettings',
  idKey: 'userId',
  // `userId == null` → `'self'` slot for the `/me/` payload, so a
  // consumer that doesn't know its own user id can still read.  All
  // other ids stringify as in the default key function.
  keyFor: id => (id == null ? 'self' : String(id)),
  api: {
    fetch: userId => UserSettingsApi.fetchUserSettings(userId),
    // `patchUserSettings` takes `(payload, userId)` — adapt to the
    // factory's `(id, payload)` shape rather than rewriting every
    // call site for one feature.
    patch: (userId, payload) => UserSettingsApi.patchUserSettings(payload, userId),
  },
});

export const selectAlarms = feature.selectSection('alarms');
export const selectContact = feature.selectSection('contact');

// Top-level + per-section hooks.
export const useUserSettings = feature.useSettings;

export default feature.reducer;
